import PaymentSummaryScreen from '@/components/masters/PaymentSummary';
import AdminHeader from '../components/common/AdminHeader';

export default function PaymentSummaryPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <main className="max-w-full mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <PaymentSummaryScreen />
      </main>
    </div>
  );
}
